// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cf0ef9fe","453":"ebba30ee","732":"c546e06c"}[chunkId] + ".chunk.js";
};